// Displays value in format 1 000 000,00
export default function formatPrice(value, decimalPlaces = 2) {
    return new Intl.NumberFormat('pl-PL', {
        style: 'decimal',
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
        useGrouping: true
    }).format(value)
}